import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";

import { api_without_cancellation } from "../../../api/api";
import PR from "../../../assets/state-svg/puerto-rico";
import GU from "../../../assets/state-svg/guam";
import MP from "../../../assets/state-svg/marian";
import VI from "../../../assets/state-svg/us-virigin-island";
import SelectStateModal from "../../TreatmentPage/modals/state-modal/SelectStateModal";

import SignaturePreview from "./SignaturePreview";
//
const EditSignatureModal = ({ show, handleClose, signatureData, onSave, onDelete }) => {
  const stateRef = useRef(null);
  const [stateShow, setStateShow] = useState(false);
  const [statesAbrs, setStatesAbrs] = useState([]);
  const [form, setForm] = useState({
    logoType: "main", // 'main', 'printing', 'none'
    use_office_contact: false,
    firmName: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    fax: "",
    email: "",
    webUrl: "",
  });

  const stateMap = {
    PR: PR,
    GU: GU,
    VI: VI,
    MP: MP,
  };
  const specialStates = Object.keys(stateMap);

  const handleStateShow = () => setStateShow(!stateShow);

  const fetchSatesData = async () => {
    try {
      const response = await api_without_cancellation.get("/api/states/");
      if (response.status === 200) {
        setStatesAbrs(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchSatesData();
  }, []);
  useEffect(() => {
    if (signatureData) {
      setForm({
        logoType: signatureData?.logoType || "main",
        use_office_contact: signatureData?.use_office_contact || false,
        firmName: signatureData?.use_office_contact
          ? signatureData?.office_address?.name
          : signatureData?.for_address?.name || "",
        address1: signatureData?.use_office_contact
          ? signatureData?.office_address?.address1
          : signatureData?.for_address?.address1 || "",
        address2: signatureData?.use_office_contact
          ? signatureData?.office_address?.address2
          : signatureData?.for_address?.address2 || "",
        city: signatureData?.use_office_contact
          ? signatureData?.office_address?.city
          : signatureData?.for_address?.city || "",
        state: signatureData?.use_office_contact
          ? signatureData?.office_address?.state
          : signatureData?.for_address?.state || "",
        zip: signatureData?.use_office_contact
          ? signatureData?.office_address?.zip
          : signatureData?.for_address?.zip || "",
        phone: signatureData?.use_office_contact
          ? signatureData?.office_address?.phone_number
          : signatureData?.for_address?.phone_number || "",
        fax: signatureData?.use_office_contact
          ? signatureData?.office_address?.fax
          : signatureData?.for_address?.fax || "",
        email: signatureData?.use_office_contact
          ? signatureData?.office_address?.email
          : signatureData?.for_address?.email || "",
        webUrl: signatureData?.use_office_contact
          ? signatureData?.office_address?.website
          : signatureData?.for_address?.website || "",
      });
    } else {
      // New signature - load default firm settings
      setForm({
        logoType: "main",
        use_office_contact: false,
        firmName: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        fax: "",
        email: "",
        webUrl: "",
      });
    }
  }, [signatureData]);

  const update = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleSave = () => {
    const updatedSignature = {
      ...signatureData,
      ...form,
    };
    onSave(updatedSignature);
    handleClose();
  };

  const handleDelete = () => {
    const updatedSignature = {
      ...signatureData,
      ...form,
    };
    onDelete(updatedSignature);
    handleClose();
  };

  const getModalTitle = () => {
    if (!signatureData) return "Generate All Firm User Email Signatures";
    if (signatureData.id === "default") return "Edit Default Firm Email Signature";
    return `Edit Email Signature - ${
      signatureData?.for_staff === null
        ? signatureData?.for_firm?.attorneyprofile?.office_name
        : `${signatureData?.for_staff?.user?.first_name} ${signatureData?.for_staff?.user?.last_name}`
    }`;
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="max-700 modal-dialog-centered"
        contentClassName="custom-modal-new-provider"
        size="lg"
        style={{
          opacity: stateShow ? "0.5" : "1",
        }}
      >
        <div style={{ minHeight: "200px" }}>
          <Modal.Header
            style={{
              borderBottom: "0px",
            }}
            className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
          >
            <Modal.Title
              className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
              id="modal_title"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              {getModalTitle()}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="p-0 m-t-5 m-l-5 m-r-5 m-b-5"
            style={{
              minHeight: "200px",
              maxHeight: "600px",
              overflowY: "auto",
            }}
          >
            <div className="custom-tab">
              {/* Logo Selection */}
              <Row className="mx-0 pe-0">
                <Col md={12} className="p-0">
                  <div className="row mx-0 align-items-center custom-margin-bottom">
                    <div className="col-md-12 p-l-0 pe-0">
                      <label
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "var(--primary)",
                          marginBottom: "5px",
                        }}
                      >
                        Logo Selection (Applies to All Signatures)
                      </label>
                      <div className="d-flex ps-1" style={{ gap: "10px" }}>
                        <label
                          className="d-flex align-items-center cursor-pointer mb-0"
                          style={{ fontSize: "14px", gap: "6px" }}
                        >
                          <input
                            type="radio"
                            name="logoType"
                            value="main"
                            checked={form.logoType === "main"}
                            onChange={() => update("logoType", "main")}
                            style={{
                              width: "13px",
                              minWidth: "13px",
                              height: "13px",
                              minHeight: "13px",
                              flexShrink: 0,
                            }}
                          />
                          <span>Firm Main Logo</span>
                        </label>

                        <label
                          className="d-flex align-items-center cursor-pointer mb-0"
                          style={{ fontSize: "14px", gap: "6px" }}
                        >
                          <input
                            type="radio"
                            name="logoType"
                            value="printing"
                            checked={form.logoType === "printing"}
                            onChange={() => update("logoType", "printing")}
                            style={{
                              width: "13px",
                              minWidth: "13px",
                              height: "13px",
                              minHeight: "13px",
                              flexShrink: 0,
                            }}
                          />
                          <span>Firm Printing Logo</span>
                        </label>

                        <label
                          className="d-flex align-items-center cursor-pointer mb-0"
                          style={{ fontSize: "14px", gap: "6px" }}
                        >
                          <input
                            type="radio"
                            name="logoType"
                            value="none"
                            checked={form.logoType === "none"}
                            onChange={() => update("logoType", "none")}
                            style={{
                              width: "13px",
                              minWidth: "13px",
                              height: "13px",
                              minHeight: "13px",
                              flexShrink: 0,
                            }}
                          />
                          <span>No Logo</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Use Home Firm Address Checkbox */}
              <Row className="mx-0 pe-0">
                <Col md={12} className="p-0">
                  <div className="row mx-0 align-items-center custom-margin-bottom">
                    <div className="col-md-12 ps-1 pe-0">
                      <label
                        className="d-flex align-items-center cursor-pointer mb-0"
                        style={{ fontSize: "14px", fontWeight: "600", gap: "6px" }}
                      >
                        <input
                          type="checkbox"
                          checked={form.use_office_contact}
                          onChange={(e) => update("use_office_contact", e.target.checked)}
                          style={{
                            width: "13px",
                            minWidth: "13px",
                            height: "13px",
                            minHeight: "13px",
                            flexShrink: 0,
                          }}
                          className="form-check mb-0"
                        />
                        <span>Use Firm User&apos;s Home Firm Address as Contact Block</span>
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Firm Name */}
              <Row className="mx-0 pe-0">
                <Col md={12} className="p-0">
                  <div className="row mx-0 align-items-center custom-margin-bottom">
                    <div className="col-md-12 height-25 p-l-0 pe-0">
                      <input
                        type="text"
                        placeholder={"Firm Name"}
                        className="form-control height-25 p-0 p-l-5 rounded-0"
                        onFocus={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }
                        }}
                        onBlur={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "Firm Name";
                          }
                        }}
                        style={{
                          color: form.use_office_contact ? "var(--primary-25)" : "black",
                        }}
                        value={form.firmName}
                        onChange={(e) => update("firmName", e.target.value)}
                        disabled={form.use_office_contact}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Address 1 & Address 2 */}
              <Row className="mx-0 pe-0">
                <Col md={12} className="p-0">
                  <div className="row mx-0 align-items-center custom-margin-bottom">
                    <div className="col-md-6 height-25 p-l-0 p-r-5">
                      <input
                        type="text"
                        placeholder={"Address 1"}
                        className="form-control height-25 p-0 p-l-5 rounded-0"
                        onFocus={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }
                        }}
                        onBlur={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "Address 1";
                          }
                        }}
                        style={{
                          color: form.use_office_contact ? "var(--primary-25)" : "black",
                        }}
                        value={form.address1}
                        onChange={(e) => update("address1", e.target.value)}
                        disabled={form.use_office_contact}
                      />
                    </div>

                    <div className="col-md-6 height-25 p-l-0 pe-0">
                      <input
                        type="text"
                        placeholder={"Address 2"}
                        className="form-control height-25 p-0 p-l-5 rounded-0"
                        onFocus={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }
                        }}
                        onBlur={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "Address 2";
                          }
                        }}
                        style={{
                          color: form.use_office_contact ? "var(--primary-25)" : "black",
                        }}
                        value={form.address2}
                        onChange={(e) => update("address2", e.target.value)}
                        disabled={form.use_office_contact}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              {/* City, State, Zip */}
              <Row className="mx-0 pe-0">
                <Col md={12} className="p-0">
                  <div className="row mx-0 align-items-center custom-margin-bottom">
                    <div className="col-md-5 height-25 p-l-0 p-r-5">
                      <input
                        type="text"
                        placeholder={"City"}
                        className="form-control height-25 p-0 p-l-5 rounded-0"
                        onFocus={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }
                        }}
                        onBlur={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "City";
                          }
                        }}
                        style={{
                          color: form.use_office_contact ? "var(--primary-25)" : "black",
                        }}
                        value={form.city}
                        onChange={(e) => update("city", e.target.value)}
                        disabled={form.use_office_contact}
                      />
                    </div>

                    <div
                      ref={stateRef}
                      className="col-md-4 height-25 p-l-0 p-r-5 custom-select-new-provider"
                    >
                      <div
                        className="dropdown-button rounded-0 p-0 p-l-5 p-r-5 form-control height-25 d-flex align-items-center"
                        onClick={form.use_office_contact ? null : handleStateShow}
                        style={{
                          cursor: form.use_office_contact ? "not-allowed" : "pointer",
                          opacity: form.use_office_contact ? 0.6 : 1,
                          background: form.use_office_contact ? "#e9ecef" : "",
                        }}
                      >
                        <span id="selectedOption">
                          {specialStates.includes(form?.state) ? (
                            <div className="d-flex align-items-center">
                              {React.createElement(stateMap[form?.state])}
                              {form?.state}
                            </div>
                          ) : form?.state ? (
                            <div className="d-flex align-items-center">
                              <svg
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  fill: "var(--primary-80)",
                                  color: "var(--primary-80)",
                                  stroke: "var(--primary-80)",
                                }}
                                className={`icon icon-state-${form?.state}`}
                              >
                                <use xlinkHref={`#icon-state-${form?.state}`} />
                              </svg>
                              {form?.state}
                            </div>
                          ) : (
                            "State"
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-3 height-25 p-l-0 pe-0">
                      <input
                        type="text"
                        placeholder={"Zip"}
                        className="form-control height-25 p-0 p-l-5 rounded-0"
                        onFocus={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }
                        }}
                        onBlur={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "Zip";
                          }
                        }}
                        style={{
                          color: form.use_office_contact ? "var(--primary-25)" : "black",
                        }}
                        value={form.zip}
                        onChange={(e) => update("zip", e.target.value)}
                        disabled={form.use_office_contact}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Phone & Fax */}
              <Row className="mx-0 pe-0">
                <Col md={12} className="p-0">
                  <div className="row mx-0 align-items-center custom-margin-bottom">
                    <div className="col-md-6 height-25 p-l-0 p-r-5">
                      <input
                        type="text"
                        placeholder={"Phone"}
                        className="form-control height-25 p-0 p-l-5 rounded-0"
                        onFocus={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }
                        }}
                        onBlur={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "Phone";
                          }
                        }}
                        style={{
                          color: form.use_office_contact ? "var(--primary-25)" : "black",
                        }}
                        value={form.phone}
                        onChange={(e) => update("phone", e.target.value)}
                        disabled={form.use_office_contact}
                      />
                    </div>

                    <div className="col-md-6 height-25 p-l-0 pe-0">
                      <input
                        type="text"
                        placeholder={"Fax"}
                        className="form-control height-25 p-0 p-l-5 rounded-0"
                        onFocus={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }
                        }}
                        onBlur={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "Fax";
                          }
                        }}
                        style={{
                          color: form.use_office_contact ? "var(--primary-25)" : "black",
                        }}
                        value={form.fax}
                        onChange={(e) => update("fax", e.target.value)}
                        disabled={form.use_office_contact}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Email & Web URL */}
              <Row className="mx-0 pe-0">
                <Col md={12} className="p-0">
                  <div className="row mx-0 align-items-center custom-margin-bottom">
                    <div className="col-md-6 height-25 p-l-0 p-r-5">
                      <input
                        type="text"
                        placeholder={"Email"}
                        className="form-control height-25 p-0 p-l-5 rounded-0"
                        onFocus={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }
                        }}
                        onBlur={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "Email";
                          }
                        }}
                        style={{
                          color: form.use_office_contact ? "var(--primary-25)" : "black",
                        }}
                        value={form.email}
                        onChange={(e) => update("email", e.target.value)}
                        disabled={form.use_office_contact}
                      />
                    </div>

                    <div className="col-md-6 height-25 p-l-0 pe-0">
                      <input
                        type="text"
                        placeholder={"Website URL"}
                        className="form-control height-25 p-0 p-l-5 rounded-0"
                        onFocus={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }
                        }}
                        onBlur={(e) => {
                          if (!form.use_office_contact) {
                            e.target.placeholder = "Web URL";
                          }
                        }}
                        style={{
                          color: form.use_office_contact ? "var(--primary-25)" : "black",
                        }}
                        value={form.webUrl}
                        onChange={(e) => update("webUrl", e.target.value)}
                        disabled={form.use_office_contact}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Preview Section */}
              {signatureData?.id && (
                <Row className="mx-0 pe-0 m-t-5">
                  <Col md={12} className="p-0">
                    <div
                      style={{
                        padding: "5px",
                        backgroundColor: "var(--primary-2)",
                        borderRadius: "0px",
                      }}
                    >
                      <h6
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "var(--primary)",
                          marginBottom: "5px",
                        }}
                      >
                        Signature Preview
                      </h6>
                      <SignaturePreview
                        signature={{
                          logoURL: signatureData?.logo_url,
                          userId: signatureData?.id,
                          userName:
                            signatureData?.for_staff === null
                              ? signatureData?.for_firm?.attorneyprofile?.office_name
                              : `${signatureData?.for_staff?.user?.first_name} ${signatureData?.for_staff?.user?.last_name}`,
                          userTitle: "",
                          ...(signatureData?.use_office_contact
                            ? signatureData?.office_address
                            : signatureData?.for_address),
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              )}
            </div>
            <div className="d-flex justify-content-between p-t-5">
              <Button
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center height-25"
                variant="secondary"
                onClick={handleClose}
              >
                Cancel
              </Button>
              {signatureData?.id && (
                <Button
                  className="button-padding-footer-new-provider d-flex align-items-center justify-content-center height-25"
                  variant="danger"
                  onClick={handleDelete}
                  style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}
                >
                  Delete
                </Button>
              )}
              <Button
                variant="success"
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center height-25"
                onClick={handleSave}
              >
                {!signatureData
                  ? "Generate All Firm User Email Signatures"
                  : `Save ${
                      signatureData?.for_staff === null
                        ? signatureData?.for_firm?.attorneyprofile?.office_name
                        : `${signatureData?.for_staff?.user?.first_name} ${signatureData?.for_staff?.user?.last_name}`
                    } Email Signature`}
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>

      {stateShow && (
        <SelectStateModal
          show={stateShow}
          handleClose={handleStateShow}
          onChange={(state) =>
            setForm({
              ...form,
              state: state.StateAbr,
            })
          }
          statesData={statesAbrs}
        />
      )}
    </>
  );
};

export default EditSignatureModal;
